'use strict';

angular.module('openDataApp')
  .controller('UpgradeFormCtrl', ['$scope', '$q', '$location', '$timeout', 'moment', 'ApiService', function ($scope, $q, $location, $timeout, Moment, ApiService) {

    $scope.timespan = { length: 1 };
    $scope.formData = { months: $scope.timespan.length };
    $scope.greatSuccess = false;

    $scope.totalAmount = 0;
    $scope.totalDiscount = 0;
    $scope.remainingDaysAmount = 0;
    $scope.planCost = 0;
    $scope.planCostPerDay = 0;

    $scope.startDate = new Moment();
    $scope.endDate = ($scope.startDate.date() === 1 ? new Moment().add($scope.formData.months, 'months').subtract(1, 'day') : new Moment().add($scope.formData.months, 'months').endOf('month'));
    $scope.remainingDays = ($scope.startDate.date() === 1 ? 0 : new Moment().endOf('month').diff($scope.startDate, 'days') + 1);

    $scope.changeTimespan = function(timespan) {
      $scope.formData.months = timespan.length;
      $scope.timespan = timespan;
      $scope.totalAmount = $scope.remainingDaysAmount + (($scope.timespan.length - ($scope.timespan.freeMonths !== undefined ? $scope.timespan.freeMonths : 0)) * $scope.planCost);
      $scope.totalDiscount = (timespan.freeMonths !== undefined ? timespan.freeMonths : 0) * $scope.planCost;
      $scope.endDate = ($scope.startDate.date() === 1 ? new Moment().add($scope.formData.months, 'months').subtract(1, 'day') : new Moment().add($scope.formData.months, 'months').endOf('month'));
      return false;
    };

    $scope.changePlan = function(plan) {
      $scope.formData.plan = plan;
      $scope.planCost = $scope.staticData.plans.normal[plan].price;
      $scope.planCostPerDay = $scope.staticData.plans.normal[plan].price / 30;
      $scope.remainingDaysAmount = Math.round(($scope.remainingDays * $scope.planCostPerDay) * 100) / 100;
      $scope.totalAmount = $scope.remainingDaysAmount + (($scope.timespan.length - ($scope.timespan.freeMonths !== undefined ? $scope.timespan.freeMonths : 0)) * $scope.planCost);
      $scope.totalDiscount = ($scope.timespan.freeMonths !== undefined ? $scope.timespan.freeMonths : 0) * $scope.planCost;
      return false;
    };

    $scope.submit = function(formData) {
      if (!$scope.greatSucces) {
        $scope.submitting = true;
        $scope.transferFormSubmitError = null;

        var def = $q.defer(),
            order = {};

        order[formData.plan] = formData.months;
        ApiService.checkout(order)
          .then(
            function success(response) {
              $scope.greatSuccess = true;
              $timeout(function () {
                window.location.href = response.data.response;
              }, 2000);
              def.resolve();
            },
            function error(response) {
              $scope.submitting = false;
              $scope.extensionFormSubmitError = response.data.error !== undefined ? response.data.error : 'Er is iets misgegaan, probeer het later nog eens.';
              def.reject();
            }
          );

        return def.promise;
      }
    };
  }]);
